import { useEffect, useState } from 'react';

const MOBILE_MAX = 767;
const TABLET_MAX = 1199;

function getMode() {
  if (typeof window === 'undefined') return 'desktop';
  if (window.innerWidth <= MOBILE_MAX) return 'mobile';
  if (window.innerWidth <= TABLET_MAX) return 'tablet';
  return 'desktop';
}

export function useViewportMode() {
  const [mode, setMode] = useState(getMode);

  useEffect(() => {
    const handleResize = () => setMode(getMode());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mode;
}
